function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "live-camera_inline_svg__a",
  d: "M0 0h16v10.4H0z"
}));

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("mask", {
  id: "live-camera_inline_svg__b",
  fill: "#fff"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#live-camera_inline_svg__a"
})), /*#__PURE__*/React.createElement("path", {
  d: "M2.173 3.702a1.052 1.052 0 01-1.044-1.06c0-.585.468-1.058 1.045-1.058s1.045.474 1.045 1.059-.468 1.059-1.045 1.059zM10.113 0H1.1A1.11 1.11 0 000 1.116v8.17A1.11 1.11 0 001.1 10.4h9.013a1.11 1.11 0 001.1-1.114V7.422l.912.456 2.961 1.479c.503.25.914-.008.914-.576V1.62c0-.567-.41-.826-.913-.576l-2.962 1.48-.913.455V1.116A1.11 1.11 0 0010.113 0z",
  fill: "#000",
  mask: "url(#live-camera_inline_svg__b)"
}));

function SvgLiveCamerainline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 11
  }, props), _ref, _ref2);
}

export default SvgLiveCamerainline;